import React, { useContext, useState, useEffect, MouseEventHandler } from 'react';
import { UserContext } from '../UserContext';
import { PageContext } from '../PageContext';
import { Col, Container, Row } from 'reactstrap';
import { Button, Toolbar, ToolbarItem } from '@progress/kendo-react-buttons';
import { Grid, GridColumn, GridCellProps, GridDataStateChangeEvent, GridPageChangeEvent,getSelectedState,GridSelectionChangeEvent} from '@progress/kendo-react-grid';
import { Input,Checkbox, CheckboxChangeEvent, InputChangeEvent, Switch, SwitchChangeEvent } from '@progress/kendo-react-inputs';
import { DatCatSizeDataItem, upDatCatSizeDataItem, SiteEntry, ColTypeEntry, DatModSizeDataItem, upDatModSizeDataItem } from '../../services/interfaces';
import { saveDatCatSize, deleteDatCatSize, getDatCatSizeList, getDatModSizeList, saveDatModSize, deleteDatModSize } from '../../services/apiAdminService';
import { getStatusList, getSubStatusList } from '../../services/apiService';
import { process, State, DataResult } from '@progress/kendo-data-query';
import { getter } from '@progress/kendo-react-common';
import { PagerTargetEvent } from '@progress/kendo-react-data-tools';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { Label } from '@progress/kendo-react-labels';
import { data } from 'react-router-dom';
import { ConfirmDialog } from '../ConfirmDialog';
import { ColTypeList, SiteList, StatusList } from '../FormComponents';

interface PageState {
    skip: number;
    take: number;
}

//const initialPageState: PageState = { skip: 0, take: 20 };

const initialDataState: State = {
    sort: [{ field: 'category', dir: 'asc' }],
    filter: undefined,
    skip:0,
    take:20
};

interface editProps{
    size:DatModSizeDataItem,
    title: string,
    onClose: () => void;
    action:string
}

export interface NewSize
{
    modCategory:string
    size:string
    strIn:string
    strOut:string
    modID:number
    siteCode:string
}


const EditDialog=(props:editProps)=>{

    const [newSize, setNewSize]= useState<NewSize>(
        {
            modCategory:"",
            size:"",
            strIn:"",
            strOut:"",
            modID:0,
            siteCode:""
        }
    );
    const [dlgTitle, setDlgTitle]=useState<string>("");
    const [selectedSize,setSelectedSize]=useState([]);
    const [showDelConfirm, setShowDelConfirm]=useState(false);
    const [showDeleteButton, setShowDeleteButton]=useState(true);
    const [intAction,setIntAction]=useState("");
    const [siteValid, setSiteValid]=useState(false);
    const [sizeValid, setSizeValid]=useState({
        siteCode:false,
        modCategory:false,
        strIn:false
    });
    const setSiteCode=(e: SiteEntry[])=>{
        setNewSize({...newSize, siteCode: (e[0].code) || ''})  
    }

    const setCategory=(e: InputChangeEvent)=>{
        setNewSize({...newSize, modCategory: (e.value)})
    }

    const setStrIn=(e: InputChangeEvent)=>{
        setNewSize({...newSize, strIn: e.value})
    }

    const setStrOut=(e: InputChangeEvent)=>{
        setNewSize({...newSize, strOut: e.value})
    }

    const setDisplayName=(e: InputChangeEvent)=>{
        setNewSize({...newSize, size: e.value})
    }
    


    const validateSize= async()=>{
        var sizeValid={
            siteCode:false,
            modCategory:false,
            strIn:false
        }
        if (newSize.modCategory!=""){
            sizeValid.modCategory=true;
        }
        if (newSize.siteCode!==""){
            sizeValid.siteCode=true;
        }
        if (newSize.strIn!==""){
            sizeValid.strIn=true;
        }
        setSizeValid(sizeValid);
       return (sizeValid);
    }
    

    const viewDeleteButton=()=>{
        setShowDeleteButton(true);
    }

    const hideDeleteButton=()=>{
        setShowDeleteButton(false);
    }


    const viewDelConfirm=()=>{
        setShowDelConfirm(true);
    }

    const hideDelConfirm=()=>{
        setShowDelConfirm(false);
    }



    const deleteThisSize=()=>{
        if (props.action=="Edit"){
            const category = newSize.modCategory;
            const site = newSize.siteCode;
            const size = newSize.strIn
            if (site!="" && category!="" && size!=""){
               deleteDatModSize(category,site,size);
            }
        }        
        hideDelConfirm();
        props.onClose();
    }



    const saveThisSize= async ()=>{

        var oCategory;
        var oStrIn;
        var ositeCode;
        console.log(newSize);
        validateSize().then((sizeValid)=>{
             if (sizeValid.modCategory===true && sizeValid.siteCode===true && sizeValid.strIn===true){
                 if (intAction==="Edit"){
                    //edit existing pub
                    oCategory=props.size.modCategory;
                    oStrIn=props.size.strIn;
                    ositeCode=props.size.siteCode;
                 }else{
                     //create new pub
                    oCategory="";
                    oStrIn="";
                    ositeCode="";
                 }
                 var formData:upDatModSizeDataItem = {
                    oModCategory: oCategory,
                    oStrIn:oStrIn,
                    oSiteCode:ositeCode,
                    modCategory:newSize.modCategory,
                    siteCode: newSize.siteCode,
                    strIn:newSize.strIn,
                    strOut:newSize.strOut,
                    size:newSize.size,
                    modID:newSize.modID                    
                  };
                 console.log(formData);
                 saveDatModSize(formData).then((data)=>{
                     console.log(data);
                     props.onClose();
                 });    
             }else{
                 console.log("Missing fields");
             }    
        });
        
    }

    useEffect(()=>{
        console.log(newSize);
        validateSize();
    },[newSize])

    useEffect(() => {  
        setDlgTitle(props.title);
        console.log(props.size); 
        if (props.size){
            setNewSize({
                modCategory:props.size.modCategory,
                size:props.size.size,
                strIn:props.size.strIn,
                strOut:props.size.strOut,
                modID:props.size.modID,
                siteCode:props.size.siteCode
            });            
        }
        setIntAction(props.action);
        if (props.action==="Edit"){
            viewDeleteButton();
        }else{
            hideDeleteButton();
        }
    },[]);
    return(
        <>
        <Dialog title={dlgTitle} onClose={props.onClose} width={700} height={"45vh"}>
            {showDelConfirm?<ConfirmDialog title='Delete Sub-status Entry' message='This will permanently delete the selected sub-status entry. This can not be undone. Are you sure you want to continue?' type='WARN' confirmButtonText='Continue' cancelButtonText='Cancel' onClose={hideDelConfirm} onConfirm={deleteThisSize}  ></ConfirmDialog>:null}

            <Row className='mb-3'>
                <Col xs="3"><Label className='mb-2'>Site:</Label></Col>
                <Col xs="9"><SiteList value={newSize.siteCode} setReturnAction={setSiteCode} multi={false} valid={sizeValid.strIn} className="" ></SiteList></Col>
            </Row>
            <Row className='mb-3'>
                <Col xs="3"><Label className='mb-2'>Modular Type:</Label></Col>
                <Col xs="9"><Input value={newSize.modCategory} onChange={setCategory} required={true} valid={sizeValid.modCategory}></Input></Col>
            </Row>
            <Row className='mb-3'>
                <Col xs="3"><Label className='mb-2'>Order Size:</Label></Col>
                <Col xs="9"><Input value={newSize.strIn} onChange={setStrIn} valid={sizeValid.strIn}></Input></Col>
            </Row>
            <Row className='mb-3'>
                <Col xs="3"><Label className='mb-2'>Build Size:</Label></Col>
                <Col xs="9"><Input value={newSize.strOut} onChange={setStrOut}></Input></Col>
            </Row>
            <Row className='mb-3'>
                <Col xs="3"><Label className='mb-2'>Display Name:</Label></Col>
                <Col xs="9"><Input value={newSize.size} onChange={setDisplayName}></Input></Col>
            </Row>
            <DialogActionsBar>
                <Button themeColor={"secondary"}onClick={props.onClose}>Cancel</Button>
                <Button themeColor={"primary"} onClick={saveThisSize}>Save</Button>
                {showDeleteButton?<Button themeColor={"warning"} onClick={viewDelConfirm}>Delete</Button>:null}
            </DialogActionsBar>
        </Dialog>
        </>
    )
}

export default function AdminModSizes (){
    const userContext = useContext(UserContext);
    const pageContext = useContext(PageContext);
    const user = userContext?.user;
    const [site, setSite] = useState<SiteEntry>({
        code:"",
        name:"",
        logo_Prefix:"",
        primary_ip:"",
        backup_ip:"",
        temp_Char:"",
        temp_Int:0,
        vol1_Unc_Path:"",
        vol2_Unc_Path:""
    });

    const [colType, setColType]= useState<ColTypeEntry[]>([{
        type:"",
        category:"",
        display:"",
        site:"",
        specView:""
    }])

    const [sizes, setSizes] = useState([]);
    const [sizeSelected, setSizeSelected]=useState<DatModSizeDataItem>();
    const [showEditDialog,setShowEditDialog]=useState(false);
    const [title,setTitle]=useState("");
    const [dataState, setDataState]=useState<State>(initialDataState);
    const [dataResult, setDataResult]=useState<DataResult>(process(sizes,dataState));
    //const [page, setPage] = React.useState<PageState>(initialPageState);
    const [action,setAction]=useState("Edit");
    const [selectedState, setSelectedState] = React.useState<{
        [id: string]: boolean | number[];
    }>({});

    function setSearchSite(selSite:SiteEntry[]){
        //console.log(site);
        setSite(selSite[0]);
    }

    function setSearchColType(selType:ColTypeEntry[]){
        //console.log(site);
        setColType(selType);
    }
    const idGetter = getter('pubNum');

    const setSelectedSubStat=(size:DatModSizeDataItem)=>{
        setSizeSelected(size);
    }

    const hideEditDialog=()=>{
        setShowEditDialog(false);
        getModSizes();
    }

    const newEditDialog=(e: React.MouseEvent<HTMLButtonElement>)=>{
        setAction("New");
        setTitle("New Size");
        setSizeSelected( {
            modCategory:"",
            size:"",
            strIn:"",
            strOut:"",
            modID:0,
            siteCode:""
        })
        setShowEditDialog(true);
    }



    const getModSizes=()=>{
        getDatModSizeList(site.code,colType[0].category).then(data=>{
            setSizes(data);
            //setDataResult(process(data, dataState));
        })
    }

    const onDataStateChange = (e: GridDataStateChangeEvent) => {
        setDataState(e.dataState);
        //setDataResult(process(sizes, e.dataState));
    };

    const processedData=process(sizes,dataState);
    // const pageChange = (event: GridPageChangeEvent) => {
    //     const targetEvent = event.targetEvent as PagerTargetEvent;        
    //     setPage({
    //         ...event.page,
    //         take:20
    //     });
    // }

    const onSelectionChange = (event: GridSelectionChangeEvent) => {
        console.log("Selection changed");
        console.log(event.startDataItem);
        const size:DatModSizeDataItem=event.startDataItem;
        setSizeSelected(size);

        const newSelectedState = getSelectedState({
            event,
            selectedState: selectedState,
            dataItemKey: "category"
        });
        console.log(Object.keys(newSelectedState)[0]);
        setSelectedState(newSelectedState);
    };

    useEffect(()=>{
        console.log(sizeSelected);
        if (sizeSelected){
            setTitle("Configure Modular Types/Sizes: " + sizeSelected?.size);
            setShowEditDialog(true);
        }
    },[sizeSelected])
   
    useEffect(() => {   
        if (user?.loggedIn){
            if (colType[0].category!==""){
                getModSizes();
            }
        }else{
            window.location.replace("/Login");
        }
    }, [colType]);

    return (
        <>
        {user?.loggedIn && user.type==5 ?
        <Container fluid>
            <h2>Modular Size Management</h2>
            <Toolbar>
                <SiteList value={site} setReturnAction={setSearchSite} multi={false} className='toolbarField' valid={true}></SiteList>
                <ColTypeList value={colType} multi={false} setReturnAction={setSearchColType} valid={true} site={site} adType={'M'} className='toolbarField'></ColTypeList>
                <Button title="New Size" themeColor={'primary'} type="button" onClick={newEditDialog}>
                    New Size
                </Button>       
            </Toolbar>
            <Grid
                data={processedData}
                // data={(dataResult.data.slice(page.skip, page.take + page.skip))?.map((item)=>({
                //     ...item, 'selected':selectedState[idGetter(item)]
                // }))}
                dataItemKey='UID'
                id="sizeGrid"
                className='adminGrid'
                sortable={true}
                selectable={{ enabled:true, mode: 'single' }}
                pageable={{
                    buttonCount: 4,
                    info:true,                
                    pageSizeValue: 20
                }}
                {...dataState}
                onDataStateChange={onDataStateChange}
                // onPageChange={pageChange}
                onSelectionChange={onSelectionChange}
                // skip={page.skip}
                // take={page.take}
                // total={dataResult.total}
                reorderable={true}
                filterable={true}
            >
                <GridColumn field='siteCode' title='Site' width={150} />
                <GridColumn field='modCategory' title='Ad Type'/>
                <GridColumn field='size' title='Display Name'/>
                <GridColumn field='strIn' title='Order Size'/>
                <GridColumn field='strOut' title='Actual Size'/>
            </Grid>
            {showEditDialog?
                <EditDialog title={title} size={sizeSelected as DatModSizeDataItem} onClose={hideEditDialog} action={action}></EditDialog>
            :null
            }
        </Container>
        : <></>}
        </>
    );
}